import React from "react";
import OrderAgingDashboard from "./OrderAgingDashboard";
import DirtyOrders from "./DirtyOrders";

function App() {
  return (
    <>
      <OrderAgingDashboard />
      <DirtyOrders />
    </>
  );
}

export default App;
